import { useCallback } from 'react';

import { isNotDefined } from '@hsp/utilities';

import { isMultiData } from '@u/is-multi-data';

import { IClient } from 'types/api/client';
import { IClientProps } from 'types/components/client';

export const useSelectedClients = <AllowMultiple extends boolean = false>({
  clients,
  selected,
}: Pick<IClientProps<AllowMultiple>, 'selected'> & {
  clients?: IClient[];
}) => {
  return useCallback(() => {
    if (isNotDefined(selected)) {
      return null;
    }

    const values: IClient[] = [...(isMultiData(selected) ? selected : [selected])];

    return (clients ?? []).filter(({ id }) => {
      return values.find((item) => item.id === id);
    });
  }, [clients, selected]);
};
